import React from "react";

export const LoadingComp = ({ customStyle = {} }) => {
  return (
    <img
      src="/assets/images/svg/loading.svg"
      className="loading"
      alt="Loading. . ."
      style={customStyle}
    />
  );
};

export const ProgressBar = ({ progress, customStyle = {} }) => {
  return (
    <div style={customStyle}>
      <div className="progress">
        <div className="progress-bar" style={{ width: `${progress}%` }}>
          {progress}%
        </div>
      </div>
    </div>
  );
};

export default { LoadingComp, ProgressBar };
